<template>
  <div class="row">
    <div class="col-md-12 h4" v-for="transaction in transactions">
      {{transaction.gateway | underscoresToSpaces | capitalize}}:
      {{transaction.amount| currency}} /
      {{transaction.maximum_refundable| currency}}
      {{transaction.currency | capitalize}}
    </div>
  </div>
</template>

<script>
  import {
    currency,
    underscoresToSpaces,
    capitalize,
  } from '../../../filters';

  export default {
    name: 'RefundTransactions',
    props: {
      transactions: {
        required: true,
        type: [Array, null, undefined],
        default: []
      },
    },
    filters: {
      currency,
      underscoresToSpaces,
      capitalize,
    },
  };
</script>
